import { useQuery } from "@tanstack/react-query";
import useWidgetStore from "../../store/useWidgetStore";
import ConfigHolder from "../../config/ConfigHolder";
import { prepareUrl } from "../../context/WidgetContext";
import { useSettings } from "../../context/SettingsContext";
import dayjs from "dayjs";
export const useSubscriptions = (options) => {
    const { api_key, widget_id } = useSettings();
    const { enabled, selectedApptype, selectedDate, consumer, booking } = useWidgetStore();
    const defaultOptions = Object.assign(Object.assign({}, options), { enabled: enabled.apptype, networkMode: "always", cacheTime: 0, staleTime: 0 });
    return useQuery(Object.assign(Object.assign({}, defaultOptions), { queryKey: ['widget-subscriptions', consumer, selectedApptype, selectedDate, booking], queryFn: async ({ signal }) => {
            var _a, _b, _c, _d;
            let url = new URL(`/consumer/booking/api/method/getSubscriptionTypes`, ConfigHolder.apiBaseUrl);
            let _appTypes = (booking === null || booking === void 0 ? void 0 : booking.appointments) && (booking === null || booking === void 0 ? void 0 : booking.appointments[0]) ? (_c = (_b = (_a = booking === null || booking === void 0 ? void 0 : booking.appointments[0]) === null || _a === void 0 ? void 0 : _a.components[0]) === null || _b === void 0 ? void 0 : _b.appointmentTypes) === null || _c === void 0 ? void 0 : _c.join(',') : undefined, _date = (booking === null || booking === void 0 ? void 0 : booking.appointments) && (booking === null || booking === void 0 ? void 0 : booking.appointments[0]) ? dayjs((_d = booking === null || booking === void 0 ? void 0 : booking.appointments[0]) === null || _d === void 0 ? void 0 : _d.date).format('YYYY-MM-DD') : '';
            let _params = {
                date: _date,
                consumerId: consumer === null || consumer === void 0 ? void 0 : consumer.id
            };
            if (_appTypes) {
                _params.appType = _appTypes;
            }
            // The date and app type above are those of the first appointment. The limits of a membership
            // (f.e. 2 appointments per week) hold for all the appointments of the booking together, so
            // they are all posted, and each membership answers for each of them whether it pays.
            if ((booking === null || booking === void 0 ? void 0 : booking.appointments) && booking.appointments.length > 0) {
                _params.appointments = JSON.stringify(booking.appointments.map((appointment) => {
                    var _a, _b;
                    return ({
                        appTypeId: (_b = (_a = appointment.components[0]) === null || _a === void 0 ? void 0 : _a.appointmentTypes) === null || _b === void 0 ? void 0 : _b[0],
                        date: dayjs(appointment.date).format('YYYY-MM-DD'),
                        time: dayjs(appointment.date).format('HH:mm')
                    });
                }));
            }
            url = prepareUrl(url, 'getSubscriptionTypes', api_key, widget_id, _params);
            const response = await fetch(url.href, {
                signal: signal,
                headers: {
                    'accept': 'application/ld+json',
                }
            });
            return response.json();
        } }));
};
